import { Injectable } from '@angular/core'
import { IUserPreferences } from '@exchange/domain/.'

@Injectable()
export class UserPreferencesService {
  private _key = 'userprefs'

  public getUserPreferences(): IUserPreferences {
    const prefsJson = sessionStorage.getItem(this._key)
    if (prefsJson) {
      const prefs = JSON.parse(prefsJson)
      prefs.acceptedTermsV2 = new Date(prefs.acceptedTermsV2)

      return prefs as IUserPreferences
    }
    return {} as IUserPreferences
  }

  public setUserPreferences(userprefs: IUserPreferences): void {
    sessionStorage.setItem(this._key, JSON.stringify(userprefs || {}))
  }
}
